var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6955bfa1a2e18981edcfc6ee677f02e5.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9d45dfac2bf2bbae2360de2748c45e38.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f4dc65c02fcd368e66153d494c3c85ae.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    